import React from "react";

import Button from "../../../components/Safra/Button";
import Icon from "../../../components/Safra/Icon";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Footer from "../../../components/Safra/Footer";
import { trackHotelBooking } from "../../../utils/analytics";

import {
    Container,
    ContainerImgText,
    ContainerCarousel,
    ErrorTitle
} from "./styles";

export default function CheckoutMessage() {
    const navigation = useNavigate();

    const {id} = useParams()
    const location = useLocation()
    const hotelData = location.state?.order_details

    React.useEffect(() => {
        if (id && hotelData) {
            trackHotelBooking({
                order_id: id,
                ...hotelData
            });
        }
    }, [id, hotelData]);

    const SuccessMessage = () => {
        return (
            <>
                <Container>
                    <ContainerImgText>
                        <Icon
                            className="img-aprovado"
                            name="circle-check"
                            size={130}
                            color="#8AB8CC"
                            title="Reserva aprovada"
                        />
                        <p className="resgate">Sua reserva foi aprovada</p>
                        <p className="infor">
                            Você receberá os detalhes da sua reserva em seu email
                            cadastrado
                        </p>
                        <div className="protocolo">
                            <p>Nº do Pedido</p>
                            <span>{id}</span>
                        </div>

                        <ContainerCarousel>
                            <Button className="btn-home" onClick={() => navigation("/")}>Voltar para página
                                inicial</Button>
                        </ContainerCarousel>
                    </ContainerImgText>
                </Container>
            </>
        )
    }

    const ErrorMessage = () => {
        return (
            <>
                <Container>
                    <Icon
                        name="triangle-alert"
                        size={130}
                        color="#8AB8CC"
                        style={{ marginTop: "50px" }}
                        title="Pagamento nao autorizado"
                    />
                    <ErrorTitle>Pagamento não autorizado</ErrorTitle>

                    <span>
                        Revise seus dados e/ou altere a sua forma de pagamento.
                        Caso não seja possível realizar sua reserva, tente novamente mais tarde.
                    </span>

                    <Button style={{marginTop: "200px"}} onClick={() => window.history.back()} className="top">Voltar ao pagamento</Button>
                </Container>
            </>
        )
    }

    return (
        <>
            {id ? <SuccessMessage/> : <ErrorMessage/>}
            <Footer />
        </>
    );
}
